// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-js" + "-" + "87b40c65f801b7c2b3ba" + ".js";
};